import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'new_complaint',
  govern: {
    'can route': function route() {
      return this.isAdmin() || this.isCRM();
    },
    'can createComplaint': function createComplaint() {
      return this.isAdmin() || this.isCRM();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/newPerimeter.js